
<div *ngIf="processing">
  <div id="globalLoader" [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h1>Loading</h1>
  </div>
</div>

<div *ngIf="!processing">
    <div class="flex flex-row gap-2 justify-start items-center mb-4">
      <h1 class="portal-page-title">Online payment duplicate detected</h1>
    </div>

    <mat-card class="portal-notice" *ngIf="isValid">
      <span >The payment processing system has detected a <strong>Duplicate</strong> payment. <br/><br />
        <ul>
          <li>Please contact the appropriate team via the <strong><a [routerLink]="['/messages']" >Messaging System</a></strong> to look into the issue.  </li>
        </ul>
      </span>
    </mat-card>
  </div>

